import React from 'react'

import CheckIcon from '../../assets/icons/check';
import CloseIcon from '../../assets/icons/close';

function CURPReport() {
    return (
        <div className="sandbox_report_wrapper">
            <h2>Result report:</h2>
            <div className="sandbox_tags">
                <div className="tag tag_success">
                    <span>Seguro</span>
                </div>
            </div>
            <div className="api_log_list">
                <h4>Score</h4>
                <div className="api_log_score">
                    <span>0</span>
                    <p>Una puntuación de 0-100 que indica la probabilidad de que la dirección de correo electrónico del usuario sea fraudulenta. Un correo electrónico con una puntuación de 8 o más es riesgoso.</p>
                </div>
            </div>
            
            <div className="api_log_list">
                <h4>Detalles de la dirección IP privada</h4>
                <div class="api_log_detail">
                    <span>País</span>
                    <span class="api_log_detail_value">MX</span>
                </div>
                <div class="api_log_detail">
                    <span>Estado/Provincia</span>
                    <span class="api_log_detail_value">México</span>
                </div>
                <div class="api_log_detail">
                    <span>Ciudad</span>
                    <span class="api_log_detail_value">Toluca</span>
                </div>
                <div class="api_log_detail">
                    <span>Diferencia de huso horario</span>
                    <span class="api_log_detail_value">-06:00</span>
                </div>
                <div class="api_log_detail">
                    <span>Tipo</span>
                    <span class="api_log_detail_value">ISP</span>
                </div>
                <div class="api_log_detail">
                    <span>Longitud</span>
                    <span class="api_log_detail_value">-99.65324</span>
                </div>
                <div class="api_log_detail">
                    <span>Latitud</span>
                    <span class="api_log_detail_value">19.28786</span>
                </div>
                <div class="api_log_detail">
                    <span>Nombre del ISP</span>
                    <span class="api_log_detail_value">Uninet</span>
                </div>
            </div>

            <div className="api_log_list">
                <h4>Atributos de Seguridad de la Red</h4>
                <div class="api_log_detail">
                    <span>Número de spam</span>
                    <span class="api_log_detail_value">0</span>
                </div>
            </div>

            <div className="resport_verification_tags">
                <div className="report_verification_tag  tag_verification_error">
                    <CloseIcon />
                    <span>Tor</span>
                </div>
                <div className="report_verification_tag  tag_verification_error">
                    <CloseIcon />
                    <span>VPN</span>
                </div>
                <div className="report_verification_tag  tag_verification_error">
                    <CloseIcon />
                    <span>Proxy web</span>
                </div>
                <div className="report_verification_tag  tag_verification_error">
                    <CloseIcon />
                    <span>Proxy público</span>
                </div>
            </div>

        </div>
    )
}

export default CURPReport